<template>
  <div class="campaign-header" :class="{ 'ipl-campaign': isIPLCampaign }">
    <div class="wrapper">
      <div class="logo-box">
        <a href='https://www.cricketapi.com' title="Cricket API">
          <img class="logo" src="@/assets/rca-logo-black.svg" alt="Cricket API Logo" />
        </a>
      </div>
      <ul>
        <li class="hide-on-desktop">
          <a :href="supportNumbers.indianNumber.link" target="_self" class="link-plain"
            title="Indian Support Number">
            <img src="@/assets/rsCricket/phone_in_talk.svg" alt="Contact button"/>
          </a>
        </li>
        <li
          v-for="(link, i) in menuItems"
          :key="link.key"
        >
          <TextButton
            :buttonType="i === 0 ? 'rs-button primary' : 'rs-button blue-cta'"
            v-if="link"
            :link="link"></TextButton>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.campaign-header {
  border: 1px solid #F5ECEC;
  background: #FAF5F5;
  box-shadow: 0 2px 12px 0 rgba(17, 17, 17, 0.10);

  .wrapper {
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: size(12) size(20);
    max-width: size(320);

    @media screen and (min-width:  $breakpoint-md) {
      max-width: size(700);
    }

    @media screen and (min-width:  $breakpoint-lg) {
      max-width: size(1200);
    }
  }

  .logo-box {
    display: flex;
    align-items: center;
    gap: size(12);
    .logo {
      height: size(40);
    }
  }
  ul {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: size(12);
    font-size: size(16);
    line-height: size(24);

    .hide-on-desktop {
      @media screen and (min-width:  $breakpoint-md) {
        display: none;
      }
    }

    li {
      &:nth-child(3) {
        display: none;
        @media screen and (min-width:  $breakpoint-md) {
          display: block;
        }
      }
    }
  }
}

</style>
<style lang="scss">
.campaign-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 100;
  .wrapper {
     ul {
      li {
        .text-button {
          a {
            margin-top: 0;
            padding: size(8) size(12);
            font-size: size(12);
            line-height: size(16);
            color: var(--rs-white-color);

            @media screen and (min-width:  $breakpoint-md) {
              padding: size(10) size(20);
              font-size: size(14);
              line-height: size(20);
            }
          }
        }
        &:nth-child(3) {
          .text-button {
            a {
              color: var(--rs-white-color);
            }
          }
        }
        &:nth-child(2) {
          .text-button {
            a {
              border-color: var(--rs-cta-blue-color);
              color: var(--rs-cta-blue-color);

              &:after {
                border-color: var(--rs-cta-blue-color);
              }
            }
          }
        }
      }
    }
  }
}

</style>
<script>
import { mapState } from 'vuex';
import TextButton from '@/components/RZWebsite/TextButton.vue';
import { supportNumbers } from '@/store/modules/page';

export default {
  name: 'CampaignHeader',
  components: {
    TextButton,
  },
  computed: {
    ...mapState({
      activeProject: (state) => state.project.activeProject,
      bootData: (state) => state.boot.instance,
    }),
  },
  props: {
    menuItems: {
      type: Array,
      default: () => [],
    },
    isIPLCampaign: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      supportNumbers,
    };
  },
};
</script>
